import { getChartPalette } from "../theme";
import type { ChartContext } from "./context";

export function buildRadarOption(
  context: ChartContext,
): Record<string, unknown> {
  const { data, isDark, translateNode, unitText, ct, base } = context;
  const indicator = data.labels.map((name) => ({ name }));
  return {
    ...base,
    tooltip: {
      trigger: "item",
      backgroundColor: ct.bgElevated,
      borderColor: ct.border,
      formatter: (p: { seriesName: string; value: number[] }) =>
        `${translateNode(p.seriesName)}\n${p.value.map((v, i) => `${translateNode(data.labels[i])}: ${unitText(v)}`).join("\n")}`,
    },
    radar: {
      indicator,
      axisName: { color: ct.color, formatter: translateNode },
    },
    series: data.datasets.map((ds, i) => ({
      type: "radar",
      name: ds.label,
      data: [{ value: ds.values as number[] }],
      symbol: "circle",
      symbolSize: 4,
      lineStyle: { width: 2 },
      itemStyle: { color: getChartPalette(isDark, data.datasets.length)[i] },
    })),
  };
}
